import { render, staticRenderFns } from "./VerifyEmail.html?vue&type=template&id=5d5e6f81&scoped=true&"
import script from "./VerifyEmail.js?vue&type=script&lang=js&"
export * from "./VerifyEmail.js?vue&type=script&lang=js&"
import style0 from "./VerifyEmail.scss?vue&type=style&index=0&id=5d5e6f81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e6f81",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCardText,VContainer,VFlex,VForm,VIcon,VImg,VLayout,VProgressCircular})
